export const ArticleFiberImage = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="190" height="124" viewBox="0 0 190 124" fill="none">
    <defs>
      <style>
        {`
          .st0 {
            fill: #212e39;
          }

          .st0, .st1, .st2, .st3, .st4, .st5 {
            stroke-miterlimit: 10;
          }

          .st0, .st1, .st2, .st3, .st5 {
            stroke: #212e39;
          }

          .st0, .st1, .st2, .st4, .st5 {
            stroke-width: .95px;
          }

          .st1, .st4 {
            fill: none;
          }

          .st2 {
            fill: #f2f5f8;
          }

          .st6, .st5 {
            fill: #dee4e8;
          }

          .st7 {
            fill: #c3cdd5;
          }

          .st3 {
            fill: #9fb0bd;
            stroke-width: 1.04px;
          }

          .st4 {
            stroke: #131c24;
          }
        `}
      </style>
    </defs>
    <g id="modem">
      <g>
        <path className="st4" d="M93.49,4.29" />
        <path className="st2" d="M122.67,115.36V8.89c0-.17-.14-.3-.3-.3h-57.74c-.18,0-.32.14-.32.32v106.45" />
      </g>
      <path className="st6" d="M88.52,15.24v95.2c1.66.11,3.4.19,5.22.24V15.45c-1.52.02-3.32-.06-5.22-.21Z" />
      <path
        className="st7"
        d="M87.65,15.45c-6.67.07-18.57-1.66-21.4-3.61l.4,95.85c4.36,1.69,11.61,2.73,21,2.98V15.45Z"
      />
      <path className="st6" d="M117.96,13.74v95.45c1.11-.29,2.11-.6,2.99-.94l.4-95.85c-.67.47-1.87.92-3.38,1.34Z" />
      <g>
        <ellipse className="st5" cx="93.49" cy="8.59" rx="29.18" ry="4.29" />
        <path
          className="st0"
          d="M122.67,109.12c0,2.37-13.07,4.29-29.18,4.29s-29.18-1.92-29.18-4.29v6.24c0,2.37,13.07,4.29,29.18,4.29s29.18-1.92,29.18-4.29v-6.24Z"
        />
      </g>
      <path className="st1" d="M122.67,8.59c0,2.37-13.07,4.29-29.18,4.29s-29.18-1.92-29.18-4.29" />
    </g>
    <g id="circles">
      <circle className="st3" cx="96.2" cy="76.86" r="1.56" />
      <circle className="st3" cx="96.2" cy="85.96" r="1.56" />
      <circle className="st3" cx="96.2" cy="95.06" r="1.56" />
      <circle className="st3" cx="96.2" cy="104.16" r="1.56" />
      <circle className="st3" cx="96.2" cy="67.76" r="1.56" />
    </g>
  </svg>
);
